import { type FunctionComponent, useRef } from 'react'
import React from 'react'
import { useLanguage } from '@/context/LanguageContext'
import cn from 'classnames'
import { useDraggable } from 'react-use-draggable-scroll'
import { NETWORK_COVERAGE_TABS } from '@/lib/network-coverage-v2/networkCoverageConstants'

interface TabBarProps {
  activeTab: number
  onTabChange: (id: number) => void
}

const TabBar: FunctionComponent<TabBarProps> = ({ activeTab, onTabChange }) => {
  const { locale } = useLanguage()
  const scrollRef = useRef<HTMLDivElement>(null!)
  const { events } = useDraggable(scrollRef, { applyRubberBandEffect: false })

  return (
    <div
      className='flex bg-surfaceInverse85 justify-start items-center p-2 gap-2 rounded-2xl w-full overflow-x-scroll flex-nowrap whitespace-nowrap scrollbar-hide'
      {...events}
      ref={scrollRef}
    >
      {NETWORK_COVERAGE_TABS.map((tab) => (
        <div
          key={tab.id}
          className={cn(
            'flex-1 px-2 2xl:px-5 py-2 rounded-xl font-semibold cursor-pointer text-center text-sm',
            activeTab === tab.id
              ? 'bg-secondary text-textInverse'
              : 'bg-[#0000001A] text-textHigh'
          )}
          onClick={() => { onTabChange(tab.id) }}
        >
          <span className='flex items-center justify-center h-full w-full'>
            {locale === 'en' ? tab.nameEN : tab.nameMN}
          </span>
        </div>
      ))}
    </div>
  )
}

export default TabBar
